import React from 'react';
import PropTypes from 'prop-types';

export const StrideConversationListItem = ({ name, cloudId, conversationId }) => (
  <div className="table-row">
    <div>
      <span className="name">{name}</span>
      <span className="actions">
        <table>
          <tbody>
            <tr>
              <th scope="col">Cloud ID</th>
              <td>{cloudId}</td>
            </tr>
            <tr>
              <th scope="col">Conversation ID</th>
              <td>{conversationId}</td>
            </tr>
          </tbody>
        </table>
      </span>
    </div>
  </div>
);

StrideConversationListItem.propTypes = {
  name: PropTypes.string.isRequired,
  cloudId: PropTypes.string.isRequired,
  conversationId: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
};


const StrideConversationsAdminInfo = ({ conversations }) => (
  <div className="cpt-admin-callout">
    <div className="cpt-admin-callout-title">
      <i className="fa fa-info-circle" /> Admin Info
    </div>
    <div className="cpt-admin-callout-display">
      <div className="cpt-table standard-two-row">
        <div id="stride-conversations" className="stride-conversations content admin-info">
          <div className="table-row-group">
            { conversations.map(conversation => <StrideConversationListItem key={conversation.code} {...conversation} />)}
          </div>
        </div>
      </div>
    </div>
  </div>
);

StrideConversationsAdminInfo.propTypes = {
  conversations: PropTypes.arrayOf(PropTypes.shape(StrideConversationListItem.propTypes)).isRequired,
};

export default StrideConversationsAdminInfo;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/stride_conversations_admin_info.jsx